import { render, staticRenderFns } from "./VolunteerVerification.vue?vue&type=template&id=166767f0&"
import script from "./VolunteerVerification.vue?vue&type=script&lang=js&"
export * from "./VolunteerVerification.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerVerification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports